<template>
  <div class="PaymentPageErrorView">
    <el-row :justify="'center'" :align="'middle'" type="flex">
      <el-col :sm="13">
        <MessageInfo
          :messageType="errorMessage.type"
          :title="errorMessage.title"
          :code="errorMessage.code"
          :description="errorMessage.description"
        >
        </MessageInfo>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import store from '@/store';
import MessageInfo from '@/components/Common/MessageInfo';

export default {
  name: 'PaymentPageError',
  components: { MessageInfo },
  store,
  computed: {
    errorMessage() {
      return {
        type: 'error',
        title: this.$t('wrong_or_expired_token_page.title'),
        code: this.$t('wrong_or_expired_token_page.code'),
        description: this.$t('wrong_or_expired_token_page.description'),
      };
    },
  },
};
</script>

<style lang="sass">
  .PaymentPageErrorView
    margin-top: 10px 
</style>




// WEBPACK FOOTER //
// src/views/PaymentErrorPage.vue